module.exports = __webpack_public_path__ + "img/1.96858fe9.jpg";